<template>
  <a-layout>
    <a-space>
      <vxe-input v-model="args['no']" clearable placeholder="placeholder.no" size="small" type="search" @search-click="refresh"/>
      <vxe-input v-model="args['operator']" clearable placeholder="placeholder.operator" size="small" type="search" @search-click="refresh"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      ref="table"
      align="center"
      :data="data"
      :loading="loading"
      :keyboard-config="{isArrow: true}"
      :scroll-x="{enabled: true}"
      :row-config="{isCurrent: true, isHover: true}"
      :column-config="{resizable: true}"
      :checkbox-config="{trigger: 'row'}"
      :height="height"
      size="mini"
      style="margin-top: 2px"
      @cell-dblclick="({row})=>dblclick(row)">
      <vxe-column fixed="left" type="checkbox" width="50"/>
      <vxe-column field="order.no" title="business.label.orderNo" width="120"/>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="order.orderStatus" title="business.label.orderStatus" width="100">
        <span slot-scope="{row}">{{orderStatus.find(item => item.ordinal === row.order.orderStatus).name}}</span>
      </vxe-column>
      <vxe-column field="order.countingType" title="business.label.countingType">
        <span slot-scope="{row}">{{countingTypes.find(item => item.ordinal === row.order.countingType).name}}</span>
      </vxe-column>
      <vxe-column field="order.invoiceTime" title="business.label.invoiceTime" width="170"/>
      <vxe-column field="order.operator" title="business.label.operator"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, post } from '@/api/Api'
import Api from '@/api'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'CountingApproveTable',
  data() {
    return {
      loading: false,
      data: [],
      page: 1,
      size: 20,
      contentSize: 0,
      args: {
        'no': '',
        'operator': '',
        'orderStatus': 3
      },
      height: Vue.ls.get(SCREEN_HEIGHT) * (0.775)
    }
  },
  props: {
    orderStatus: {
      type: Array,
      default: []
    },
    countingTypes: {
      type: Array,
      default: []
    }
  },
  mounted() {
    this.refresh()
  },
  methods: {
    dblclick(row) {
      this.$emit('dblclick', row)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.refresh()
    },
    reset() {
      this.args = {
        'no': '',
        'operator': '',
        'orderStatus': 3
      }
      this.page = 1
      this.refresh()
    },
    refresh() {
      this.loading = true
      findAll('countingOrderFactory', this.args, this.page, this.size).then(res => {
        if (res.success) {
          this.data = res.result
          this.contentSize = res.contentSize
        }
      }).finally(() => this.loading = false)
    },
    approve() {
      let selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        this.$emit('fail')
        return this.$message.warning('请先选择需要审核的单据')
      }
      this.loading = true
      const args = { ids: Array.from(selectedRows.map(item => item.order.id)) }
      post(Api.countingReviewAll, { type: 'inventoryCounter' }, args).then(res => {
        if (res.success) {
          this.$message.success('审核成功')
          this.$emit('success')
        } else {
          this.$emit('fail')
        }
      }).finally(() => this.loading = false)
    },
    reject() {
      let selectedRows = this.$refs.table.getCheckboxRecords()
      if (selectedRows.length === 0) {
        this.$emit('fail')
        return this.$message.warning('请先选择需要驳回的单据')
      }
      this.loading = true
      const args = { ids: Array.from(selectedRows.map(item => item.order.id)) }
      post(Api.countingRejectAll, { type: 'inventoryCounter' }, args).then(res => {
        if (res.success) {
          this.$message.success('驳回成功')
          this.$emit('success')
        } else {
          this.$emit('fail')
        }
      }).finally(() => this.loading = false)
    }
  }
}
</script>